import styled from 'styled-components';

const LetterColumn = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export default LetterColumn;
